import React from 'react';

import { OptimizedImage } from '../../optimized-image/optimized-image';

import LoaderHoc from 'shared/components/ui/Loaders/LoaderHoc/LoaderHoc';

import polygonBlue from 'assets/animation/blocks/polygon-blue.png?format=webp;avif&as=picture';

import './MintingLoader.scss';

interface Props {
  messages?: string[];
  className?: string;
  hash?: `0x${string}` | null | '';
  selector?: string;
}
// todo: check do we need still selector prop, same  in LoaderHoc
const MintingLoader = ({ messages, className, hash, selector }: Props) => {
  return (
    <LoaderHoc messages={messages} className={className} hash={hash} selector={selector}>
      <div className="center mb-4 flex">
        <div className="polygons-container">
          <OptimizedImage
            imageData={polygonBlue}
            className="w-[60px]"
            alt="polygon blue"
            imgClassName="polygon polygon-1"
          />
          <OptimizedImage
            imageData={polygonBlue}
            className="w-[60px]"
            alt="polygon blue"
            imgClassName="polygon polygon-2"
          />
          <OptimizedImage
            imageData={polygonBlue}
            className="w-[60px]"
            alt="polygon blue"
            imgClassName="polygon polygon-3"
          />
        </div>
      </div>
    </LoaderHoc>
  );
};

export default MintingLoader;
